import styled from "styled-components";
import { TemplateColorObject } from "../../../../../InvitationColorMatrix";
import { ReactComponent as InstagramSVG } from "../../../../../assets/icons/InstagramSVG.svg";
import { Box, darken } from "@mui/material";

export const FooterContainer = styled(Box)<{ colormatrix: TemplateColorObject }>`
	background: ${props => darken(props.colormatrix.main, 0.1)};
	display: flex;
	justify-content: center;
	flex-direction: column;
	align-items: center;
	padding: 20px 0;
	position: relative;

	p {
		color: #fff;
		margin: 10px 0;
		font-family: var(--poppins), sans-serif;
		font-weight: bold;
	}

	.social {
		cursor: pointer;
		text-decoration: none;
	}
`;

export const StyledInstagram = styled(InstagramSVG)<{ colormatrix: TemplateColorObject }>`
	path {
		fill: #fff;
	}
`;
